import { REGEX } from '../../constants/regex.constants';

export function protectLongNumbers(csvText: string): string {
  const lines = csvText.split('\n');
  if (lines.length === 0) return csvText;

  const header = lines[0];
  const dataLines = lines.slice(1);

  const processedLines = dataLines.map((line) => {
    if (!line.trim()) return line;

    const cells = line.split(REGEX.differentLocalesColon);

    if (cells[0] && /^\d{10,}$/.test(cells[0].trim())) {
      cells[0] = `="${cells[0]}"`;
    }

    return cells.join(',');
  });

  return [header, ...processedLines].join('\n');
}
